module.exports = __webpack_public_path__ + "img/Abgehangen.debe63d6.jpg";